import { isString } from 'angular';
export var AttributeIconsDirective = [
    'attributeIconService',
    function (attributeIconService) {
        return {
            link: function ($scope, $element, $attributes) {
                if (!isString($scope.iconType)) {
                    $scope.iconType = '';
                }
                $scope.iconType = $scope.iconType.toLowerCase();
                var groupBy = function (array, property) {
                    return array.reduce(function (groups, item) {
                        var val = item[property];
                        groups[val] = groups[val] || [];
                        groups[val].push(item);
                        return groups;
                    }, {});
                };
                $scope.attributeIcons = [];
                $scope.flattenAttributeIcons = [];
                $scope.getFlattenList = function () {
                    var iconList = [];
                    for (var _i = 0, _a = $scope.attributeIcons; _i < _a.length; _i++) {
                        var attributeIcon = _a[_i];
                        for (var _b = 0, _c = attributeIcon.icons; _b < _c.length; _b++) {
                            var innerAttributeIcons = _c[_b];
                            iconList.push({
                                attributes: [],
                                description: attributeIcon.description,
                                icons: [innerAttributeIcons],
                            });
                        }
                    }
                    return iconList;
                };
                var promise;
                switch ($scope.iconType) {
                    case 'targetgroup':
                        promise = attributeIconService.getTargetGroup();
                        break;
                    case 'workswith':
                        promise = attributeIconService.getWorksWith();
                        break;
                    default:
                        promise = attributeIconService.getCommon();
                        break;
                }
                promise.then(function (icons) {
                    var attributes = $scope.attributes.map(function (a) {
                        var splitAttribute = a.split('|');
                        return {
                            name: splitAttribute[0],
                            value: splitAttribute[1],
                        };
                    });
                    var grouppedAttributes = groupBy(attributes, 'name');
                    var _loop_1 = function (key) {
                        var attributeMappings = grouppedAttributes[key].map(function (s) { return s.name + "|" + s.value; });
                        for (var _i = 0, icons_1 = icons; _i < icons_1.length; _i++) {
                            var icon = icons_1[_i];
                            if (icon.attributes.every(function (a) { return attributeMappings.some(function (am) { return a === am; }); })) {
                                $scope.attributeIcons.push(icon);
                                if ($scope.iconType === 'targetgroup' || $scope.iconType === 'workswith') {
                                    continue;
                                }
                                if (key === 'Product_Usage' && attributeMappings.length > 1) {
                                    break;
                                }
                            }
                        }
                    };
                    for (var _i = 0, _a = Object.keys(grouppedAttributes); _i < _a.length; _i++) {
                        var key = _a[_i];
                        _loop_1(key);
                    }
                    $scope.flattenAttributeIcons = $scope.getFlattenList();
                });
            },
            restrict: 'E',
            scope: {
                attributes: '=',
                iconCssClass: '@?',
                iconType: '@?',
            },
            template: "\n        <span class=\"{{ iconCssClass }} attribute-icons__icon icon icon__{{ attributeIcon.icons[0] }}\" \n              uib-tooltip-html=\"attributeIcon.description\" \n              tooltip-placement=\"bottom\"\n              ng-repeat=\"attributeIcon in flattenAttributeIcons\">\n        </span>\n      ",
        };
    },
];
